module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAmCAYAAABOFCLqAAAA90lEQVRYR+2WIQvCUBSFz32g/g0Fo0GjYPQfrPkDxCAM+0CEdREMYte2f2AUjBqMgla7SWFPxGQY3DMcLNzlb/cdzjm8+8Q/7h4l+cTEZCRhzmRV1JwxZ9jri+qMXwyA1xMQxTGfq7RSg4QbBfxFKDHprA833amHszwnZtyENDpqMf56hFte1DwnplTOmJiMlNlCsrx15i/rgLWd5S0mi6nYzkQ9uNFavWvS1RAu3qt5rsCTFqQbqIf7QwI3P6t5TkzZd5NPYuB2AuptSBD9uFBsZ8rkDP/srELCbTGdUU/NCVIFznmG+jcT85fdpPY7J2gxWUxsdd5J8Q+4yK0vegAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/ic_mobile.png
// module id = xqbg
// module chunks = 11 22